import { Component, OnInit } from '@angular/core';
import {
  CmsBreadcrumbsComponent,
  CmsService,
  LanguageService,
  PageMetaService,
  TranslationService,
} from '@spartacus/core';
import { CmsComponentData, PageTitleComponent } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
@Component({
    selector: 'cx-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    standalone: false
})
export class KbBreadcrumbComponent extends PageTitleComponent implements OnInit {
  crumbs$: Observable<any[]>;
  lang: string;
  subscription: Subscription = new Subscription();
  constructor(
    public override component: CmsComponentData<CmsBreadcrumbsComponent>,
    protected override pageMetaService: PageMetaService,
    private translation: TranslationService,
    private languageSerice: LanguageService,
    private cmsService: CmsService
  ) {
    super(component, pageMetaService);
    this.subscription.add(
      this.languageSerice
        .getActive()
        .pipe(
          distinctUntilChanged(),
          map((lang) => {
            if (this.lang && lang !== this.lang) {
              this.cmsService.refreshLatestPage();
            }
            this.lang = lang;
          })
        )
        .subscribe()
    );
  }
  override ngOnInit(): void {
    super.ngOnInit();
    this.setCrumbs();
  }
  private setCrumbs(): void {
    this.crumbs$ = combineLatest([
      this.pageMetaService.getMeta(),
      this.translation.translate('common.breadcrumb_home'),
    ]).pipe(
      map(([meta, textHome]) => {
        const breadcrumbs = meta?.breadcrumbs ? meta.breadcrumbs : [{ label: textHome, link: '/' }];
        return breadcrumbs;
      })
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getRouterLink(url) {
    return url?.split('?')?.length > 0 ? url.split('?')[0] : null;
  }

  getQueryParams(url) {
    const requestParams = [];
    const queryparams = url?.split('?');
    if (queryparams?.length > 1) {
      queryparams[1].split('&').map((res) => {
        const param = res?.split('=');
        if (param?.length === 2) {
          requestParams[param[0]] = param[1];
        }
      });
    }
    return requestParams;
  }
}
